import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// IMAGES
import website from "../../img/website.png";
import app from "../../img/app.png";
import system from "../../img/system.png";
import HeroBg from "../../img/Hero_Bg.png";

export default function Hero() {
    const [slide1, setSlide1] = useState(true);
    const [slide2, setSlide2] = useState(false);
    const [slide3, setSlide3] = useState(false);
    const [text1, setText1] = useState(true);
    const [text2, setText2] = useState(false);
    const [text3, setText3] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setSlide1(false);
            setSlide2(true);
            setSlide3(false);
            setText1(false);
            setText2(true);
            setText3(false);
        }, 8000);
        setTimeout(() => {
            setSlide1(false);
            setSlide2(false);
            setSlide3(true);
            setText1(false);
            setText2(false);
            setText3(true);
        }, 16000);
        setTimeout(() => {
            setSlide1(true);
            setSlide2(false);
            setSlide3(false);
            setText1(true);
            setText2(false);
            setText3(false);
        }, 24000);
        const imageInterval = setInterval(() => {
            setTimeout(() => {
                setSlide1(true);
                setSlide2(false);
                setSlide3(false);
            }, 8000);
            setTimeout(() => {
                setSlide1(false);
                setSlide2(true);
                setSlide3(false);
            }, 16000);
            setTimeout(() => {
                setSlide1(false);
                setSlide2(false);
                setSlide3(true);
            }, 24000);
        }, 24000);
        const textInterval = setInterval(() => {
            setTimeout(() => {
                setText1(true);
                setText2(false);
                setText3(false);
            }, 8000);
            setTimeout(() => {
                setText1(false);
                setText2(true);
                setText3(false);
            }, 16000);
            setTimeout(() => {
                setText1(false);
                setText2(false);
                setText3(true);
            }, 24000);
        }, 24000);
        return () => [
            clearInterval(imageInterval),
            clearInterval(textInterval),
        ];
    }, []);

    return (
        <div className="defaultHero">
            <div className="custom-container">
                <div className="hero__wrapper">
                    <div className="hero__wrapper-text">
                        <div className="build">
                            <h2>
                                <span>We</span> Build
                            </h2>
                        </div>
                        <div className="message-box">
                            <div
                                className={
                                    text1
                                        ? "message-wrap active"
                                        : "message-wrap"
                                }
                            >
                                <h1 className="char-one message-show">W</h1>
                                <h1 className="char-two message-show">e</h1>
                                <h1 className="char-three message-show">b</h1>
                                <h1 className="char-four message-show">s</h1>
                                <h1 className="char-five message-show">i</h1>
                                <h1 className="char-six message-show">t</h1>
                                <h1 className="char-seven message-show">e</h1>
                                <h1 className="char-eight message-show">s</h1>
                            </div>
                            <div
                                className={
                                    text2
                                        ? "message-wrap active"
                                        : "message-wrap"
                                }
                            >
                                <h1 className="char-one message-show">A</h1>
                                <h1 className="char-two message-show">p</h1>
                                <h1 className="char-three message-show">p</h1>
                                <h1 className="char-four message-show">l</h1>
                                <h1 className="char-five message-show">i</h1>
                                <h1 className="char-six message-show">c</h1>
                                <h1 className="char-seven message-show">a</h1>
                                <h1 className="char-eight message-show">t</h1>
                                <h1 className="char-nine message-show">i</h1>
                                <h1 className="char-ten message-show">o</h1>
                                <h1 className="char-eleven message-show">n</h1>
                            </div>
                            <div
                                className={
                                    text3
                                        ? "message-wrap active"
                                        : "message-wrap"
                                }
                            >
                                <h1 className="char-one message-show">S</h1>
                                <h1 className="char-two message-show">y</h1>
                                <h1 className="char-three message-show">s</h1>
                                <h1 className="char-four message-show">t</h1>
                                <h1 className="char-five message-show">e</h1>
                                <h1 className="char-six message-show">m</h1>
                                <h1 className="char-seven message-show">s</h1>
                            </div>
                        </div>
                        <div className="talk">
                            <Link href="" to={"/"} className="hover-e1">
                                <span className="border-left"></span>
                                <span className="border-right"></span>
                                <span className="border-top"></span>
                                <span className="border-bottom"></span>
                                Let's Talk
                            </Link>
                        </div>
                    </div>
                    <div className="hero__wrapper-img">
                        <img
                            className={slide1 ? "panel active" : "panel"}
                            src={website}
                            alt=""
                        />
                        <img
                            className={slide2 ? "panel active" : "panel"}
                            src={app}
                            alt=""
                        />
                        <img
                            className={slide3 ? "panel active" : "panel"}
                            src={system}
                            alt=""
                        />
                    </div>
                </div>
            </div>
            <div className="bg">
                <img src={HeroBg} alt="" />
            </div>
        </div>
    );
}
